<template>
	<span style="text-align: center; font-size: 21px">
		<v-btn color="primary" :disabled="disabled" block outline @click.stop="downloadXlsxTemplate(type)">
			<v-icon left>mdi-download</v-icon>Download XLSX template
		</v-btn>
	</span>
</template>

<script>
import {
	downloadSpreadSheetTemplate,
	DEFAULT_SHEET_COLUMNS,
	DEFAULT_FILE_NAME_TEMPLATE
} from '@/utils/spreadSheetFunctions';
import { getContentBodyConstructorFrom } from '@/classes/content/contentBodyFunctions';

export default {
	name: 'BulkUploadDownloadTemplates',
	props: ['type', 'referenceContent', 'disabled'],
	methods: {
		downloadXlsxTemplate(type) {
			let config = { type };
			let columns = [...DEFAULT_SHEET_COLUMNS];

			if (this.referenceContent) {
				config.$ref = this.referenceContent.$origin;
			}
			const contentBodyConstructor = getContentBodyConstructorFrom(type);
			if (typeof contentBodyConstructor.BULK_UPLOAD.columns === 'function') {
				columns = columns.concat(contentBodyConstructor.BULK_UPLOAD.columns(this.referenceContent));
			} else {
				columns = columns.concat(contentBodyConstructor.BULK_UPLOAD.columns);
			}

			const fileName = type + DEFAULT_FILE_NAME_TEMPLATE;
			downloadSpreadSheetTemplate(columns, config, fileName);
		}
	}
};
</script>
